import './styles/graphic.scss';

import axios from 'axios';
import { select } from 'd3';

export default function (props, container, isMobile) {
  // async function fetchData() {
  const {
    initialWidth,
    initialHeight,
    // width,
    // height
  } = props;

  const fetchData = function () {
    axios.get('https://ix.cnn.io/data/house-speaker-vote-2023/feed.json')
      .then((response) => {
        // handle success
        // console.log(response.data.data.HouseSpeakerRACE.candidates);

        const candidateCount = response.data.data.HouseSpeakerRACE.candidates.length;

        function ordinal_suffix_of(i) {
          const j = i % 10;
          const k = i % 100;
          if (j == 1 && k != 11) {
            return `${i}st`;
          }
          if (j == 2 && k != 12) {
            return `${i}nd`;
          }
          if (j == 3 && k != 13) {
            return `${i}rd`;
          }
          return `${i}th`;
        }

        container.html('');
        const roundLabel = select('#vote-round')
          .text(ordinal_suffix_of(response.data.data.round));
        const target = container.append('div')
          .attr('class', 'results');


        // draw here

        target.selectAll('div')
          .data(response.data.data.HouseSpeakerRACE.candidates)
          .enter()
          .append('div')
          .html(d => `<div class="g-vote-container ${d.partyAbbreviation} count-${candidateCount} ${d.winner == 1 ? 'winner' : ''}">
            <img class="g-photo" src="images/${d.candidateId}.png" alt="${d.fullName}" />
            <span class="g-votes">${d.votes}</span>
            <p class="g-name">${d.fullName} ${d.partyAbbreviation !== 'N' ? `(${d.partyAbbreviation})` : ''}</p>
          </div>`);


        const bottomLine = container.append('div')
          .attr('class', 'g-bottomLine')
          .text(() => {
            const { neededToWin } = response.data.data;
            const date = new Date(response.data.data.updatedAt).toLocaleTimeString();
            return `${neededToWin ? `${neededToWin} needed to win | ` : ''} Last updated: ${date}`;
          });

        window.pymChild.sendHeight();
      })
      .catch((error) => {
        // handle error
        console.log(error);
      })
      .finally(() => {
        // always executed
      });
  };


  // }

  fetchData();

  setInterval(() => {
    fetchData();
  }, 10000);
}
